//
//
//
//
//

export default {
  props: {
    history: {
      type: Array,
      required: true
    },
    maxLength: {
      type: [ Number, Boolean ],
      default: 55,
    }
  },
  computed: {
    workHistories () {
      const maxChars = this.maxLength
      const histories = this.history

      if (maxChars && histories.length > maxChars) {
        return histories?.substring(0, maxChars) + '...'
      }

      return histories.map(item => {
        return item.organization
      }).join(', ')
    }
  }
}
